// Listed up front; the view itself (./tab-viewer.tsx) loads on demand.
export const id = 'tab-viewer';
export const title = 'Tab viewer';
export const order = 90;
